// Copyright (c) 2017 Deere & Company

import Notification from '@deere/cps-it.warranty-model-factory/lib/notification';
import t from 'tcomb';

const Notifications = t.list(Notification, 'Notifications');

export const getDefaultState = () =>
    new Notifications([]);

export default Notifications;



// WEBPACK FOOTER //
// ./src/home-page/state/notifications.js